var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUndo = function SvgUndo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.75L5 9.375M5 9.375L9.375 5M5 9.375H14.1875C14.8195 9.375 15.4453 9.49948 16.0292 9.74133C16.613 9.98318 17.1436 10.3377 17.5905 10.7845C18.0373 11.2314 18.3918 11.762 18.6337 12.3458C18.8755 12.9297 19 13.5555 19 14.1875C19 14.8195 18.8755 15.4453 18.6337 16.0292C18.3918 16.613 18.0373 17.1436 17.5905 17.5905C17.1436 18.0373 16.613 18.3918 16.0292 18.6337C15.4453 18.8755 14.8195 19 14.1875 19H11.125",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };